import { RCancelReason, CodeNext } from '@fusion-advantage/backcompat'
import z from 'zod'

// see also Import.ts

export const REncounterCodeNextUpdate = z.object({
	SubmittingUserID: z.optional(z.string()),
	ClientDate: z.string(),
	ClientDateTime: z.string(),
	Location: z.nullable(z.string()),
	EncounterGUID: z.uuid(),
	CodeNext: z.enum(CodeNext),
	CancelReason: z.optional(RCancelReason),
})
export type EncounterCodeNextUpdate = z.infer<typeof REncounterCodeNextUpdate>
